import { useEffect } from "react";

import { useAppDispatch, useAppSelector } from "stores";

import { booleanSlice } from "./reducers";

export const useBooleanStore = ({
  name,
  defaultValue,
  syncValue,
}: {
  name: string;
  defaultValue?: boolean;
  syncValue?: boolean;
}) => {
  const dispatch = useAppDispatch();
  const boolean = useAppSelector((state) => state?.boolean?.[name]) || false;

  const set = (newBoolean: boolean) => {
    dispatch(booleanSlice.actions.set({ name, boolean: newBoolean }));
  };

  useEffect(() => {
    if (typeof defaultValue === "boolean") {
      set(defaultValue);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (syncValue !== undefined) {
      set(syncValue);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [syncValue]);

  const reset = () => {
    dispatch(booleanSlice.actions.reset(name));
  };

  return {
    boolean,
    set,
    reset,
  };
};
